export default __webpack_public_path__ + "static/media/footer-help.68985975.svg";